module.exports = __webpack_public_path__ + "static/img/second.1b6066d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tstj/second.png
// module id = Y7iY
// module chunks = 1